import React, { useEffect } from "react";

function DsrModal({ open, onClose, loading, error, html }) {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose, open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 p-4">
      <div className="relative w-[80vw] h-[80vh] bg-white dark:bg-gray-900 rounded-2xl overflow-hidden shadow-2xl border border-gray-200 dark:border-gray-700">
        <div className="h-12 px-4 flex items-center justify-between border-b border-gray-200 dark:border-gray-700">
          <div className="text-sm font-semibold text-gray-900 dark:text-gray-100">
            DSR
          </div>
          <button
            type="button"
            onClick={onClose}
            className="h-9 px-3 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-xs font-medium text-gray-900 dark:text-gray-100"
          >
            Close
          </button>
        </div>
        <div className="w-full h-[calc(80vh-3rem)] bg-white dark:bg-gray-900">
          {loading ? (
            <div className="w-full h-full flex items-center justify-center text-sm text-gray-600 dark:text-gray-300">
              Loading...
            </div>
          ) : error ? (
            <div className="w-full h-full flex items-center justify-center text-sm text-red-600 px-6 text-center">
              {error}
            </div>
          ) : (
            <iframe title="DSR" className="w-full h-full" srcDoc={html} />
          )}
        </div>
      </div>
    </div>
  );
}

export default DsrModal;

